/* ATOMS-INVOICE-MOD-REQ-2025-11 */
if (!customElements.get('cart-invoice')) {
  customElements.define('cart-invoice', class CartInvoice extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartInvoice-Overlay').addEventListener('click', this.close.bind(this));

      this.form = this.querySelector('#form-invoice');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.regimen_array = {
        "Selecciona": "Selecciona",
        601: "Regimen general de ley personas morales",
        602: "Régimen simplificado de ley personas morales",
        603: "Personas morales con fines no lucrativos",
        604: "Régimen de pequeños contribuyentes",
        605: "Régimen de sueldos y salarios e ingresos asimilados a salarios",
        606: "Régimen de arrendamiento",
        607: "Régimen de enajenación o adquisición de bienes",
        608: "Régimen de los demás ingresos",
        609: "Régimen de consolidación",
        610: "Régimen residentes en el extranjero sin establecimiento permanente en méxico",
        611: "Régimen de los ingresos por dividendos (socios y accionistas)",
        612: "Régimen de las personas físicas con actividades empresariales y profesionales",
        613: "Régimen intermedio de las personas físicas con actividades empresariales",
        614: "Régimen de los ingresos por intereses",
        615: "Régimen de los ingresos por obtención de premios",
        616: "Sin obligaciones fiscales",
        617: "Pemex",
        618: "Régimen simplificado de ley personas físicas",
        619: "Ingresos por la obtención de préstamos",
        620: "Sociedades cooperativas de producción que optan por diferir sus ingresos.",
        621: "Régimen de incorporación fiscal",
        622: "Régimen de actividades agrícolas, ganaderas, silvícolas y pesqueras pm",
        623: "Régimen de opcional para grupos de sociedades",
        624: "Régimen de los coordinados",
        625: "Régimen de las actividades empresariales con ingresos a través de plataformas tecnológicas.",
        626: "Régimen simplificado de confianza"
      }
      this.CFDI_array = {
        "Selecciona": "Selecciona",
        "G01": "Adquisición de mercancías",
        "G02": "Devoluciones, descuentos o bonificaciones",
        "G03": "Gastos en general",
        "I01": "Construcciones",
        "I02": "Mobiliario y equipo de oficina para inversiones",
        "I03": "Equipo de transporte",
        "I04": "Equipo de cómputo y accesorios",
        "I05": "Dados, troqueles, moldes, matrices y herramental",
        "I06": "Comunicaciones telefónicas",
        "I07": "Comunicaciones satelitales",
        "I08": "Otra maquinaria y equipo",
        "D01": "Honorarios médicos, dentales y hospitalarios",
        "D02": "Gastos médicos por incapacidad o discapacidad",
        "D03": "Gastos funerales",
        "D04": "Donativos",
        "D05": "Intereses reales pagados por créditos hipotecarios",
        "D06": "Aportaciones voluntarias al SAR",
        "D07": "Primas de seguros de gastos médicos",
        "D08": "Gastos de transportación escolar obligatoria",
        "D09": "Depósitos en cuentas para el ahorro, primas de pensiones",
        "D10": "Pagos por servicios educativos (colegiaturas)",
        "S01": "Sin efectos fiscales",
        "CP01": "Pagos",
        "CN01": "Nómina"
      }
      this.metodo_array = {
        "Selecciona": "Selecciona",
        "04": "Tarjeta de crédito",
        "28": "Tarjeta de débito"
      }
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy)
      console.log('Entra open invoice');
      
      setTimeout(() => {this.classList.add('animate', 'active')});

      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = document.getElementById('CartInvoice');
        const focusElement = this.querySelector('.invoice__wrapper') || this.querySelector('.invoice__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });

      document.body.classList.add('overflow-hidden');
    }
   
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    onSubmitHandler(event) {
      console.log('onSubmitHandler');
      event.preventDefault();
      /* Gets form data */
      const formData = new FormData(event.target);
      const attributes = Object.fromEntries(formData.entries());
      /* Check if the invoice is on */
      const enableInvoice = formData.get('attributes_enable_invoice');
      const postalCode = formData.get('attributes_codigo_postal');
      const postalRFC = formData.get('attributes_rfc');
      const regimen = formData.get('attributes_regimen');
      const CFDI = formData.get('attributes_CFDI');
      const metodo = formData.get('attributes_metodo');

      const postalCodeValidate = this.validatePostalCode(postalCode);
      const postalRFCValidate = this.validateRFC(postalRFC);
      const message = this.querySelector('#invoice-message');

      /* Clean message styles*/
      message.textContent = '';
      message.classList.remove('is-active');
      message.classList.remove('is-success');

      // if (enableInvoice === "true" && postalCodeValidate === true && postalRFCValidate === true ){
      if ( postalCodeValidate === true && postalRFCValidate === true && regimen != "Selecciona" && CFDI != "Selecciona" && metodo != "Selecciona" ){
        
        /* add attributes rfc, cfdi y metodo */
        attributes.attributes_regimen_text = this.regimen_array[attributes.attributes_regimen];
        attributes.attributes_CFDI_text = this.CFDI_array[attributes.attributes_CFDI];
        attributes.attributes_metodo_text = this.metodo_array[attributes.attributes_metodo];
        attributes.attributes_enable_invoice = "true";

        console.log( attributes );
        
        const body = JSON.stringify({
          attributes,
          sections: this.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
        /* Update cart with data */
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((response) => {
          this.close();
          console.log('this.getSectionsToRender() submit');

          const checked_button = document.querySelector('#CartDrawer-Invoice');
          const open_invoice = document.querySelector('cart-open-invoice');
          const edit_invoice = document.querySelector('cart-edit-invoice');
          checked_button.checked = true;
          open_invoice.classList.add('is-hidden');
          edit_invoice.classList.add('active');
          
          this.renderContents(response, false);
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }
      if(postalCodeValidate === false){
        console.log('CP minimo 5 digitos');

        message.classList.add('is-active');
        message.textContent = 'CP minimo 5 digitos';
      }
      if(postalRFCValidate === false){
        console.log('RFC 12 digitos a 13 digitos');
        
        message.classList.add('is-active');
        message.textContent = 'RFC 12 digitos a 13 digitos';
      }
      
      if(metodo === "Selecciona"){
        console.log('Selecciona una opción válida en los campos de Método de pago');
        
        message.classList.add('is-active');
        message.textContent = 'Selecciona una opción válida en los campos de Método de pago';
      }
      if(CFDI === "Selecciona"){
        console.log('Selecciona una opción válida en los campos de CFDI');
        
        message.classList.add('is-active');
        message.textContent = 'Selecciona una opción válida en los campos de CFDI';
      }
      if(regimen === "Selecciona"){
        console.log('Selecciona una opción válida en los campos de Régimen');
        
        message.classList.add('is-active');
        message.textContent = 'Selecciona una opción válida en los campos de Régimen';
      }
    }

    validatePostalCode(codigo) {
      const regex = /^\d{5}$/;
      return regex.test(codigo);
    }

    validateRFC(codigo) {
      const regex = /^.{12,13}$/;
      return regex.test(codigo);
    }

    undapteInvoice(attributes, enableRender){
      const body = JSON.stringify({
        attributes,
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
      /* Update cart with data */
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
          console.log('this.getSectionsToRender() update');
          this.renderContents(response, enableRender);
      });
    }

    renderContents(parsedState, enableRender) {
      console.log('RENDER I');
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      setTimeout(() => {
        this.querySelector('#CartInvoice-Overlay').addEventListener('click', this.close.bind(this));
        if (enableRender) { this.open(); }
        this.form = this.querySelector('#form-invoice');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-invoice',
          selector: '#CartInvoice'
        }
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  });
}

if (!customElements.get('select-invoice')) {
  customElements.define('select-invoice', class InvoiceSelect extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        selectInput: this.querySelector('select[id^="InvoiceForm"]'),
        listOptions: this.querySelector('[id^="ListMenuOption"]'),
        menuOptions: this.querySelector('[id^="SelectMenuOptions"]')
      }
      
      this.elements.menuOptions.addEventListener('click', this.openMenu.bind(this));

      this.elements.listOptions.querySelectorAll('.option').forEach((optionList) => {
        optionList.addEventListener('click', this.setOption.bind(this));
      });

      // Cerrar menú al hacer click fuera
      document.addEventListener('click', this.handleDocumentClick.bind(this));
    }

    openMenu(selectOption) {
      console.log('open menu');
      const menu = this.elements.menuOptions.closest('.form-invoice__field-menu');
      menu.classList.toggle('open');
      this.menuIsOpen = menu.classList.contains('open');
    }

    handleDocumentClick(event) {
      // Si el menú no está abierto, no hacer nada
      const menu = this.elements.menuOptions.closest('.form-invoice__field-menu');
      if (!menu.classList.contains('open')) return;
      // Si el click fue dentro del componente, no hacer nada
      if (this.contains(event.target)) return;
      // Si el click fue fuera, cerrar el menú
      menu.classList.remove('open');
    }

    setOption(optionItem) {
      console.log('select Option');
      
      const optionValue = optionItem.target.dataset.value;
      const optionLabel = optionItem.target.dataset.label;
      const menu = this.elements.menuOptions.closest('.form-invoice__field-menu');
      this.elements.listOptions.querySelectorAll('.option').forEach((element) => {
        element.classList.remove('selected');
      });
      optionItem.target.classList.add('selected');
      menu.classList.remove('open');

      if(this.elements.selectInput.id === 'InvoiceFormWO-Metodo' || this.elements.selectInput.id === 'InvoiceForm-Metodo'){
        this.elements.menuOptions.innerHTML = `${optionLabel}`;
      } else {
        this.elements.menuOptions.innerHTML = `${optionValue} ${optionLabel}`;
      }

      this.elements.selectInput.value = optionValue;
    };

    /* metodo para resetear */
    reset() {
      // Forzar select al valor "Selecciona"
      this.elements.selectInput.value = "Selecciona";

      // Buscar la opción <li> que tenga data-value="Selecciona"
      const firstOption = this.elements.listOptions.querySelector('.option[data-value="Selecciona"]');

      // Quitar selección previa
      this.elements.listOptions.querySelectorAll('.option').forEach(el => el.classList.remove('selected'));

      // Marcar y mostrar "Selecciona"
      if (firstOption) {
        firstOption.classList.add('selected');
        this.elements.menuOptions.innerHTML = firstOption.innerText;
      } else {
        // fallback: si no existe esa opción, usar la primera
        const fallback = this.elements.listOptions.querySelector('.option');
        if (fallback) {
          fallback.classList.add('selected');
          this.elements.menuOptions.innerHTML = fallback.innerText;
          this.elements.selectInput.value = fallback.dataset.value;
        }
      }
    }

  });
};
